/* NA LEIBERL – Handschrift-Hinweis mit Pfeil beim Personalisierungs-Feld (Gelato Personalizer)
   Erscheint nur bei Produkten mit Textfeld (z. B. Geburtsjahr). Der Pfeil zeichnet sich,
   sobald das Feld ins Bild scrollt. Text unten bei ZEILE_1 / ZEILE_2 aenderbar. */
(function () {
  // Zeile 1 und 2 (werden untereinander angezeigt)
  var ZEILE_1 = 'Dein Geburtsjahr';
  var ZEILE_2 = 'kommt aufs Shirt!';
  // Geschwungener Pfeil mit kleiner Schleife. Breite Spalte: links vom Text. Schmale Spalte (Handy):
  // per CSS gespiegelt rechts vom Text, damit er nie das Label "Geburtsjahr" kreuzt.
  var ARROW = '<svg class="nl-hint__arrow" viewBox="0 0 70 70" fill="none" aria-hidden="true" focusable="false">' +
    '<path class="nl-hint__line" pathLength="1" d="M66 14c-10-6-22-6-28 2-5 7 1 15 7 11 6-4-1-14-12-11C20 20 13 36 14 58"/>' +
    '<path class="nl-hint__head" pathLength="1" d="M7 51l7 9 7-9"/></svg>';
  var io = null;

  function reveal(el) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.classList.add('is-visible'); return; }
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
    }
    io.observe(el);
  }

  function attach() {
    var field = document.querySelector('.product__info-container .g-selector-container.g-selector-text');
    if (!field) return;
    if (field.querySelector('.nl-hint')) {
      // Gelato setzt bei Fehlermeldungen die Klassen neu -> unsere Klasse wieder ergaenzen
      if (!field.classList.contains('nl-has-hint')) field.classList.add('nl-has-hint');
      return;
    }
    field.classList.add('nl-has-hint');
    var hint = document.createElement('div');
    hint.className = 'nl-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = ARROW + '<span class="nl-hint__text"><span>' + ZEILE_1 + '</span> <span>' + ZEILE_2 + '</span></span>';
    field.insertBefore(hint, field.firstChild);
    // Wurde der Hinweis schon einmal gezeigt (z. B. nach Neuaufbau durch Gelato), nicht nochmal animieren
    if (window.__nlHintShown) hint.classList.add('is-visible', 'no-anim'); else reveal(hint);
    hint.addEventListener('transitionend', function () { window.__nlHintShown = true; }, { once: true });
  }

  var scheduled = false;
  function init() {
    attach();
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; attach(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
